export const REGEXP_HTTP = /^(f|ht)tps?:\/\//i
export const REGEXP_CARD_NUMBER = /[0-9*]{1,4}/g
